import type { SpaceDocument } from 'types/space';

/**
 * Root component id used by every synthetic preview document built for a code-backed `CATALOG`
 * entry. Exported so callers that need to address the single node (selection, canvas focus) do
 * not re-derive the literal.
 */
export const PREVIEW_ROOT_ID = 'preview-root';

/**
 * Wraps a bare catalog component type in the minimal valid `SpaceDocument` the composer canvas
 * needs to render it as a single-node preview. Code-backed entries have no authored document of
 * their own, so both the gallery card preview and the locked `/compose/composition/:name` view
 * synthesize one — this is the single definition they share, so the shape (`formatVersion`,
 * `catalogVersion`, `surface`, `a2ui`) cannot drift between the two call sites.
 */
export const buildCatalogPreviewDocument = (componentType: string): SpaceDocument => ({
  formatVersion: 'space/v1',
  catalogVersion: 1,
  surface: { family: componentType, componentId: PREVIEW_ROOT_ID, layout: 'uniform' },
  a2ui: {
    version: 'v1.0',
    catalogId: 'center-platform',
    root: PREVIEW_ROOT_ID,
    components: [{ id: PREVIEW_ROOT_ID, component: componentType }],
  },
});
